






































































































import Vue from 'vue';
import moment from 'moment';
import * as _ from 'lodash';
import { Component, Prop, Watch } from "vue-property-decorator";
import TextInput from "./../Card/Body/CardType/Form/FieldTypes/TextInput.vue";
import TextArea from "./../Card/Body/CardType/Form/FieldTypes/TextArea.vue";
import Number from "./../Card/Body/CardType/Form/FieldTypes/Number.vue";
import ComboBox from "./../Card/Body/CardType/Form/FieldTypes/ComboBox.vue";
import MultiSelect from "./../Card/Body/CardType/Form/FieldTypes/MultiSelect.vue";
import Date from "./../Card/Body/CardType/Form/FieldTypes/Date.vue";
import File from "./../Card/Body/CardType/Form/FieldTypes/File.vue";
import Spacer from "./../Card/Body/CardType/Form/FieldTypes/Spacer.vue";
import SwitchInput from "./../Card/Body/CardType/Form/FieldTypes/SwitchInput.vue";
// import RadioButtonList from "./../Card/Body/CardType/Form/FieldTypes/RadioButtonList.vue";
import CheckboxList from "./../Card/Body/CardType/Form/FieldTypes/CheckboxList.vue";
import InitiativeIndicatorMappingHeaderComponent from "./../Card/Body/CardType/Form/FieldTypes/InitiativeIndicatorMappingHeader.vue";

/*
    * Component's properties and events
*/
@Component({
      components: { 
        TextInput, 
        TextArea, 
        Number, 
        ComboBox, 
        MultiSelect,
        Date, 
        File,
        Spacer,
        SwitchInput,
        // RadioButtonList,
        CheckboxList,
        InitiativeIndicatorMappingHeaderComponent
    }
})

export default class DialogComponent extends Vue  {
   /*
        * Component's props
   */
   public editedIndex: number = -1;
   public editedItem: any = {};
   public defaultItem: any = {};

   /*
        *  A component�s settings option must be a function, so that each instance can maintain an independent copy of the returned data object.
   */
    get settings() {
        // @ts-ignore
        return this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName];
   }

   /*
        * Dialog title bind based on the current operation
   */
    get _dgTitle() {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName],
           title = context.title;

       //#.Apply translation to title
       if (context.keyTranslator) {
           title = this.$t(title) || title;

           return context.editedIndex === -1 ? (context.messages.new + ' ' + title) : (context.messages.edit + ' ' + title);
       }

        return context.editedIndex === -1 ? ('New ' + title) : ('Edit ' + title);
   } 
        
   /*
        * While computed properties are more appropriate in most cases, there are times when a custom watcher is necessary. 
        * That�s why Vue provides a more generic way to react to data changes through the watch option. 
   */
   @Watch('dialog')
   onPropertyChanged(value: string, oldValue: string) {
        value || this._dgClose()
   }  

   closeDialog(e)
   {
       //@ts-ignore
       let context = this.$store.state[this.$options.parent.settings.fileName];

        //#.Reset the current operation
        context.formCreate = false;
        context.editedIndex = -1;

        //#.Remove dialog component in DOM
        context.dialog = false;

        //#.Reset the edit itme object
        context.editedItem = Object.assign({}, context.defaultItem);
   }

    /*
        * Card Type: Grid - Saves add/ editing form to the server and updates the record on the table.
        * id - current componet id pass to parent key fields
        * record - Saving object
        * item - Displaying object (foreign key fields display text saving based on the id)
   */
   _dgSave(saveAndContinue) {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName],
            id = window.location.hash.substr(1),
            index = context.editedIndex,
            record = {},
            self = this;

        //#.Disable the enabled save button
        context.buttonDisabled = true;
     
       if (context.editedIndex == -1) {
           
            //#.Current operation action
            let createActions = context.actions.createAction, item = {};

            //#.Pass parent key value to child components
            let parentKey = context.fields.find(x => x.parent == true);

            if (parentKey)
                context.editedItem[parentKey.value] = id;

            //#.Fetch primary key field and set value to zero
            let keyField = context.fields.filter(x => x.primaryKey == true).find(x => x).value;

            if (keyField)
                context.editedItem[keyField] = 0;

            //#.Masked false to the server and updates the record on the table.e
            context.fields.filter(x => x.mask && x.mask.enabled == true).forEach(key => {
                if (item[key.value])
                    record[key.value] = (item[key.value]).toString().replace(/\D+/g, '');
            });

           //#.Fetch Switch input values
           context.fields.filter(x => x.type == 'SwitchInput').forEach(key => {
               record[key.value] = item[key.value];

               if (record[key.value] == true || record[key.value] == 1) {
                   item[key.value] = 1;
                   record[key.value] = 1;
               } else {
                   record[key.value] = 0;
                   item[key.value] = 0;
               }

               //#.Check form action be direct form submit or not
               if (!context.ajaxFormSubmit) {
                   this._dtFormSubmit(context, key, record);
               }
           });

            //#.Fetch foreign key field values with single value
            context.fields.filter(x => x.type == 'ComboBox').forEach(key => {
                if (context.editedItem[key.value] != null && typeof (context.editedItem[key.value]) == "object") {
                    record[key.value] = context.editedItem[key.value].Value;
                    item[key.value] = context.editedItem[key.value].DisplayText;
                } else if (!context.editedItem[key.value]) {
                    record[key.value] = null;

                    if (key.required && context.ajaxFormSubmit)
                        context.editedItem[key.value] = -1;
                }

                //#.Check form action be direct form submit or not
                if (!context.ajaxFormSubmit) {
                    this._dtFormSubmit(context, key, record);
                }
            });

            //#.Fetch date value based on the settings
            context.fields.filter(x => x.type == 'Date').forEach(key => {
                if (context.editedItem[key.value]) {
                    if (key.displayFormat && key.displayFormat.toLowerCase().indexOf('y') < 0){
                        record[key.value] = moment(key.date, context.defaultDateFormat).format('YYYY-MM-DD');
                    } else{
                        record[key.value] = moment(context.editedItem[key.value], key.displayFormat  || context.defaultDateFormat).format('YYYY-MM-DD');
                    }

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        this._dtFormSubmit(context, key, record);
                    }
                }

                //# Issue with  not nullable Date field
                if (context.editedItem[key.value] == "" && key.required) {
                    context.editedItem[key.value] = undefined;
                }
            });

            //#.Fetch currency value based on the settings
            context.fields.filter(x => x.type == 'Number' && x.currency && x.currency.enabled).forEach(key => {
                let patternWithoutDecimalSeparator = new RegExp("[^0-9-" + context.currency.decimal + "\\s]", "gi");
                record[key.value] = (context.editedItem[key.value]).replace(patternWithoutDecimalSeparator, '').replace(/\s+/g, "");

                //#.Check form action be direct form submit or not
                if (!context.ajaxFormSubmit) {
                    this._dtFormSubmit(context, key, record);
                }
            });

            //#.Added hiden/primaryKey/foreignKey fields values in new object
            // @ts-ignore
            _.forOwn(context.editedItem, function (val, key) {
                if (!record[key] && typeof (val) != 'object') {
                    record[key] = val;

                    if (val == "" || val == null) {
                        record[key] = undefined;
                    }

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        self._dtFormSubmit(context, key, record);
                    }
                }

                if (!item[key])
                    item[key] = val;
            });

            //#.Create action are triggered with the store.dispatch method.
            this.$store.dispatch('Create', { item: item, record: record, keyField: keyField, createActions: createActions, context: context, saveAndContinue: saveAndContinue, self: this });

            return;
        }

        if (context.editedIndex > -1) {
            //#.Current operation action
            let updateActions = context.actions.updateAction,
                item = context.editedItem;

            //#.Masked false to the server and updates the record on the table.e
            context.fields.filter(x => x.mask && x.mask.enabled == true).forEach(key => {
                if (item[key.value])
                    record[key.value] = (item[key.value]).toString().replace(/\D+/g, '');
            });

            //#.Fetch foreign key field values with single value
            context.fields.filter(x => x.type == 'ComboBox').forEach(key => {
                if (context.editedItem[key.value] != null && typeof (context.editedItem[key.value]) == "object") {
                    record[key.value] = context.editedItem[key.value].Value;
                    item[key.value] = context.editedItem[key.value].DisplayText;
                } else if (!context.editedItem[key.value] || context.editedItem[key.value] == -1) {
                    record[key.value] = null;

                    if (key.required && context.ajaxFormSubmit)
                        context.editedItem[key.value] = -1;

                } else if (key.select && context.editedItem[key.value] == key.select.DisplayText) {
                    record[key.value] = key.select.Value;
                } else {
                    record[key.value] = key.dropdown.find(x => x.DisplayText == context.editedItem[key.value]).Value;
                }

                //#.Check form action be direct form submit or not
                if (!context.ajaxFormSubmit) {
                    this._dtFormSubmit(context, key, record);
                }
            });

            //#.Fetch Switch input values
            context.fields.filter(x => x.type == 'SwitchInput').forEach(key => {
                record[key.value] = context.editedItem[key.value];

                if (record[key.value] == true || record[key.value] == 1) {
                    context.editedItem[key.value] = 1;
                    record[key.value] = 1;
                } else {
                    record[key.value] = 0;
                    context.editedItem[key.value] = 0;
                }

                //#.Check form action be direct form submit or not
                if (!context.ajaxFormSubmit) {
                    this._dtFormSubmit(context, key, record);
                }
            });

            //#.Fetch date value based on the settings
            context.fields.filter(x => x.type == 'Date').forEach(key => {
                if (context.editedItem[key.value]) {
                    if (key.displayFormat && key.displayFormat.toLowerCase().indexOf('y') < 0){
                        record[key.value] = moment(key.date, context.defaultDateFormat).format('YYYY-MM-DD');
                    }else {
                        record[key.value] = moment(context.editedItem[key.value], key.displayFormat  || context.defaultDateFormat).format('YYYY-MM-DD');
                    }

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        this._dtFormSubmit(context, key, record);
                    }
                }

                //# Issue with  not nullable Date field
                if (context.editedItem[key.value] == "" && key.required) {
                    context.editedItem[key.value] = undefined;
                }
            });

            //#.Fetch currency value based on the settings
            context.fields.filter(x => x.type == 'Number' && x.currency && x.currency.enabled).forEach(key => {
                let patternWithoutDecimalSeparator = new RegExp("[^0-9-" + context.currency.decimal + "\\s]", "gi");
                record[key.value] = (context.editedItem[key.value]).replace(patternWithoutDecimalSeparator, '').replace(/\s+/g, "");

                //#.Check form action be direct form submit or not
                if (!context.ajaxFormSubmit) {
                    this._dtFormSubmit(context, key, record);
                }
            });

            //#.Added hiden/primaryKey/foreignKey fields values in new object
            // @ts-ignore
            _.forOwn(context.editedItem, function (val, key) {
                if (!record[key] && record[key] != 0) {
                    record[key] = val;

                    //#.Check form action be direct form submit or not
                    if (!context.ajaxFormSubmit) {
                        self._dtFormSubmit(context, key, record);
                    }
                }

                if (!item[key])
                    item[key] = val;
            });

            //#.Update action are triggered with the store.dispatch method.
            // @ts-ignore
            this.$store.dispatch('Update', { record, item, index, updateActions, context, self });
        }
    }

    /*
        * Override the create new record submit method
        * Direct form submit for file upload added     
    */
    _dtFormSubmit(context, key, record) {
        if (!context.editedItem["FormData"])
            context.editedItem["FormData"] = new FormData();

        if (record[key.value])
            context.editedItem["FormData"].append(key.value, record[key.value]);
        else if (record[key])
            context.editedItem["FormData"].append(key, record[key]);
    }

    /*
        * _dgClose - Dialog close when clicking dialog close button
    */
    _dgClose() {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.settings.fileName];
        //#.Reset error ui
        context.fields.filter(x => x.error != null).forEach(key => {
            key.error = null;
        });

        //#.Reset the current operation
        context.formCreate = false;
        context.editedIndex = -1;

        //#.Remove dialog component in DOM
        context.dialog = false;

        //#.Reset the edit itme object
        context.editedItem = Object.assign({}, context.defaultItem);
    }   
}
